// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"0ff4469c","453":"272a2e5a","732":"869ee58a"}[chunkId] + ".chunk.js";
};